import { SORTING_PROFILES } from './constants'

export const getProfileKeyByName = (profileName) =>
    Object.keys(SORTING_PROFILES).find((key) => SORTING_PROFILES[key] === profileName)
